let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: "共享预约订单ID",
    props: "reserveOrderNo",
    minWidth: 280,
  },
  {
    label: "关联充电订单ID",
    props: "orderNo",
    minWidth: 280,
  },
  {
    label: "共享预约类型",
    props: "reserveTypeName",
    minWidth: 280,
  },
  {
    label: "预约设备编号/IMEI",
    props: "deviceCode",
    minWidth: 200,
  },
  {
    label: "设备所属用户手机号",
    props: "custMobile",
    minWidth: 180,
  },
  {
    label: "充电用户账号类型",
    props: "custTypeName",
    minWidth: 150,
  },
  {
    label: "下单用户手机号",
    props: "custPhone",
    minWidth: 150,
  },
  {
    label: "站点名称",
    props: "stationName",
    minWidth: 150,
  },
  {
    label: "站点地址",
    props: "stationAddr",
    minWidth: 320,
  },
  {
    label: "预约业务归属",
    props: "bindSourceName",
    minWidth: 200,
  },
  {
    label: "共享设备类型",
    props: "deviceTypeName",
    minWidth: 200,
  },
  {
    label: "订单状态",
    props: "orderStatusName",
    minWidth: 200,
  },
  {
    label: "当前预约开始时间",
    props: "localReserveBeginTime",
    minWidth: 200,
  },
  {
    label: "当前预约结束时间",
    props: "localReserveEndTime",
    minWidth: 200,
  },
  {
    label: "下单时间",
    props: "reserveTime",
    minWidth: 200,
  },
  {
    label: "修改次数",
    props: "updateCount",
    minWidth: 200,
  },
  {
    label: "原始预约开始时间",
    props: "beforeReserveBeginTime",
    minWidth: 200,
  },
  {
    label: "原始预约结束时间",
    props: "beforeReserveEndTime",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "remark",
    minWidth: 200,
  },
  {
    label: "更新时间",
    props: "lastModifiedWhen",
    minWidth: 200,
  },
];

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "订单管理",
  },
  {
    type: "title",
    name: "个人站共享订单",
  },
  {
    type: "title",
    name: "共享预约订单",
  },
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};

// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "id",
  editRouter: "pileDetail",
};

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "订单管理",
  },
  {
    type: "title",
    name: "个人站共享订单",
  },
  {
    type: "title",
    name: "共享预约订单",
  },
  {
    type: "title",
    name: "订单详情",
  },
];

export default pageConfig;
